import { createColumnHelper } from '@tanstack/react-table'
import dayjs from 'dayjs'

import { Root } from './types'

const columnHelper = createColumnHelper<Root>()

export const COLUMNS = [
  columnHelper.display({
    id: 'no',
    header: 'No.',
    enableSorting: false,
    size: 80,
    cell: (info) => {
      return info.row.index + 1
    },
  }),
  columnHelper.accessor('qrId', {
    cell: info => info.getValue(),
    header: () => <span>QR ID</span>,
    enableSorting: true,
  }),
  columnHelper.accessor('linked', {
    cell: info => info.getValue() ? 'Linked' : 'Not Linked',
    header: () => <span>Linked</span>,
    enableSorting: true,
  }),
  columnHelper.accessor('site.name', {
    cell: info => info.getValue(),
    header: () => <span>Site</span>,
    enableSorting: true,
  }),
  columnHelper.accessor('createdOn', {
    cell: info => dayjs(info.getValue()).format('YYYY-MM-DD HH:mm:ss'),
    header: () => <span>Created On</span>,
    enableSorting: true,
  }),
]
